import {
  Lightning,
  Target,
  Globe,
  Wallet,
} from "@phosphor-icons/react";

const features = [
  {
    icon: Lightning,
    title: "AI-Powered Analysis",
    description: "GPT-5.2 analyzes global markets, economic indicators, and business intelligence daily."
  },
  {
    icon: Target,
    title: "High Probability",
    description: "Only opportunities with 70%+ probability of success based on solid fundamentals."
  },
  {
    icon: Globe,
    title: "Global Execution",
    description: "Execute from USA, UK, UAE, or Africa with region-specific guides and requirements."
  },
  {
    icon: Wallet,
    title: "Direct Trading Links",
    description: "Live links to open accounts, fund, and execute trades immediately."
  }
];

export function FeaturesSection({ isDark }) {
  return (
    <section className={`py-20 px-4 sm:px-6 lg:px-8 ${isDark ? 'bg-[#0c0c16]' : 'bg-gray-50'}`}>
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <p className="text-purple-500 text-sm font-semibold tracking-widest uppercase mb-4">Features</p>
          <h2 className={`text-3xl sm:text-4xl font-bold ${isDark ? 'text-white' : 'text-gray-900'}`}>
            Built for Serious Investors
          </h2>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
          {features.map((feature) => (
            <div 
              key={feature.title} 
              className={`flex gap-5 p-6 rounded-xl border transition-colors ${isDark ? 'bg-[#12121a] border-white/5 hover:border-purple-500/30' : 'bg-white border-gray-200 hover:border-purple-300'}`}
            >
              <div className={`w-12 h-12 rounded-lg flex items-center justify-center flex-shrink-0 ${isDark ? 'bg-purple-600/10' : 'bg-purple-100'}`}>
                <feature.icon size={24} className="text-purple-500" weight="duotone" />
              </div>
              <div>
                <h3 className={`text-lg font-bold mb-2 ${isDark ? 'text-white' : 'text-gray-900'}`}>{feature.title}</h3>
                <p className={`text-sm ${isDark ? 'text-gray-400' : 'text-gray-600'}`}>{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
